var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploadImgs"},[_c('el-upload',{attrs:{"action":_vm.action,"list-type":"picture-card","on-remove":_vm.handleRemove,"multiple":"","on-success":_vm.handleAvatarSuccess,"file-list":_vm.fileList,"disabled":_vm.disabled}},[_c('i',{staticClass:"el-icon-plus"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }